export default "__VITE_ASSET__lG1NYZgS__"